import cn from 'classnames';
import React from 'react';
import type { SCFormFieldProps } from './form_field';
import { SCFormField } from './form_field';
import './form_field_date_time.css';
import './styles.css';

interface SCFormFieldDateTimeProps extends SCFormFieldProps {
  type?: 'date' | 'datetime-local' | 'time';
  onChange?: (value: string) => void;
}

// from eone-ui
// FIXME: inconsistency:
// eone-ui/form-string.tsx: {props.RequiredStringIndicator ?? "*"}
// eone-ui/form-input.tsx: const DefaultRequiredStringIndicator = " *";
// const DefaultRequiredStringIndicator = " *";
const DefaultRequiredStringIndicator = '*';

// The value as the native input accepts it. A datetime-local input shows anything that is not
// yyyy-MM-ddTHH:mm[:ss] as blank, so a stored date without a time ("2025-11-01") or with a space
// before the time ("2025-11-01 13:45:00") is shown as midnight or with a T. Display only: the form
// value is unchanged until the user edits the field.
function toInputValue(value: string | undefined, type: SCFormFieldDateTimeProps['type']) {
  if (!value) return '';
  if (type === 'date') return value.substring(0, 10);
  if (type === 'datetime-local') {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return `${value}T00:00`;
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(value)) return value.replace(' ', 'T');
  }
  return value;
}

const SCFormFieldDateTime = (props: SCFormFieldDateTimeProps) => {
  const {
    type = 'datetime-local',
    label,
    name,
    required,
    disabled,
    rules,
    onChange,
    DataTestId,
  } = props;
  return (
    <SCFormField label={label} name={name} disabled={disabled} required={required} rules={rules}>
      {({ field }) => {
        return (
          <React.Fragment>
            {label ? (
              <div style={{ marginBottom: '7px' }}>
                <span>{label + ((required && DefaultRequiredStringIndicator) || '')}</span>
              </div>
            ) : null}
            {/*<FormLabel Label={label + ((required && DefaultRequiredStringIndicator) || '')} />*/}
            <div
              className={cn('eone-ui-input-container', 'sc-form-field-date-time', {
                disabled: field.disabled,
              })}
              data-testid={DataTestId}
            >
              <input
                type={type}
                required={required}
                disabled={field.disabled}
                value={toInputValue(field.value, type)}
                onChange={(e) => {
                  field.onChange(e.target.value);
                  onChange?.(e.target.value);
                }}
                className="eone-ui-input-string"
                data-testid={DataTestId}
              />
            </div>
          </React.Fragment>
        );
      }}
    </SCFormField>
  );
};

export { SCFormFieldDateTime };
export type { SCFormFieldDateTimeProps };
